import { Amplify } from 'aws-amplify';
import Auth from '@aws-amplify/auth';
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolClientId: '2cr6g741v5k6faefr0cv489vib', 
            userPoolId: "us-east-2_Hv1wC1aQo",
            loginWith: {
                username: true,
                email: true,
                phone: false,
            }
            // mandatorySignIn: true,
        },
    },
});

